/**
 * Organization Consolidation API Slice
 * RTK Query endpoints for Phase 2 Enhanced RBAC Architecture
 */

import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../Features/API/baseQueryWithReauth';
import { getApiBaseUrl } from '../../../shared/constants/api';

const BASE_URL = getApiBaseUrl();

export const consolidationApiSlice = createApi({
  reducerPath: 'consolidationApi',
  baseQuery: baseQueryWithReauth(BASE_URL),
  tagTypes: ['ConsolidationSuggestion', 'ConsolidationPreview'],
  endpoints: (builder) => ({
    // Analyze all organizations for consolidation opportunities
    analyzeOrganizationConsolidation: builder.mutation({
      query: () => ({
        url: 'ai/consolidation/analyze/',
        method: 'GET',
      }),
      invalidatesTags: ['ConsolidationSuggestion'],
    }),

    // Preview the impact of a specific consolidation
    previewConsolidation: builder.mutation({
      query: (consolidationData) => ({
        url: 'ai/consolidation/preview/',
        method: 'POST',
        body: consolidationData,
      }),
      providesTags: ['ConsolidationPreview'],
    }),

  }),
});

export const {
  useAnalyzeOrganizationConsolidationMutation,
  usePreviewConsolidationMutation,
} = consolidationApiSlice;
